import { useEffect } from "react";
import { useToast } from "@/hooks/useToast";

/**
 * Listens for the `demo:blocked` CustomEvent dispatched by the Axios 403
 * interceptor and converts it into a conversion-oriented toast. Mounted
 * once near the root; has no own UI.
 */
export function DemoBlockedBridge() {
  const { addToast } = useToast();

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail as
        | { code?: string; message?: string; signupUrl?: string }
        | undefined;
      const message =
        detail?.message ??
        "This action isn't available in demo mode. Sign up for full access!";
      addToast("info", `${message} — lenavio.com/signup`);
    };
    window.addEventListener("demo:blocked", handler as EventListener);
    return () =>
      window.removeEventListener("demo:blocked", handler as EventListener);
  }, [addToast]);

  return null;
}
